export const arrayFunction = () => {
  /**
   * 获取数组对象下某个元素相对的下标
   * @param {Object} array 需要遍历的数组对象 
   * @param {String} key 需要遍历的数组对象里的key值
   * @param {String} keyWord 需要查下标的值
   */
  const findCertainIndex = (arr = [],key,keyWord) =>{
    // return arr.findIdex(item => item[key] === keyWord)
    return arr.map(item => item[key]).indexOf(keyWord)	
  }

  return {
    findCertainIndex
  }
}